import { useTranslation } from 'react-i18next';

export type SupportedLanguage = 'sq' | 'en';

export interface LanguageOption {
  code: SupportedLanguage;
  label: string;
  flag: string;
}

export const LANGUAGES: LanguageOption[] = [
  { code: 'sq', label: 'Shqip', flag: '🇦🇱' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

export function useLanguage() {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language as SupportedLanguage;

  function changeLanguage(lang: SupportedLanguage) {
    i18n.changeLanguage(lang);
  }

  return { currentLanguage, changeLanguage, languages: LANGUAGES };
}
